/**
 * Account Deletion Requests Service (Owner review queue)
 *
 * Only the owner deletes accounts. Admins and users file a request instead;
 * the owner lists, approves (which deletes) or rejects them here.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const accountDeletionService = {
  /**
   * @param {"pending"|"approved"|"rejected"|"all"} status
   * @returns {Promise<{ items: Array, total: number, pending_count: number }>}
   */
  async list(status = "pending") {
    const { data } = await apiClient.get(
      API_ENDPOINTS.ADMIN.ACCOUNT_DELETION_REQUESTS,
      { params: { status, limit: 200 } }
    );
    return data;
  },

  async approve(id, note) {
    const { data } = await apiClient.post(
      API_ENDPOINTS.ADMIN.ACCOUNT_DELETION_REQUEST_APPROVE(id),
      note ? { note } : {}
    );
    return data;
  },

  async reject(id, note) {
    const { data } = await apiClient.post(
      API_ENDPOINTS.ADMIN.ACCOUNT_DELETION_REQUEST_REJECT(id),
      note ? { note } : {}
    );
    return data;
  },
};

export default accountDeletionService;
